module.exports = __webpack_public_path__ + "fcb7b07a3e76fd9ddbc7707b02e28dc8.svg";